export default __webpack_public_path__ + "static/media/HowToHighlight.0941e471.gif";